import React from 'react';
import { Switch } from 'react-router-dom';
import SafetyRoute from 'components/kea/SafetyRoute';
import { Redirect } from 'react-router';
import PropTypes from 'prop-types';
import OnboardingVisualRecs from 'containers/OnboardingVisualRecs';

const VisualRecsRouter = ({ match }) => {
  const { url } = match;
  const dashboardUrl = `${url}/dashboard`;
  return (
    <Switch>
      <SafetyRoute
        path={`${url}/onboarding`}
        render={(props) => <OnboardingVisualRecs {...props} />}
      />
      <SafetyRoute component={() => <Redirect to={dashboardUrl} />} />
    </Switch>
  );
};

export default VisualRecsRouter;

VisualRecsRouter.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string,
  }).isRequired,
};
